<template>
  <the-protocol :list="list" />
</template>

<script>
import TheProtocol from '@/components/TheProtocol'

export default {
  components: { TheProtocol },
  async asyncData({ app, $winstonLog }) {
    // 法律协议列表
    try {
      const list = await app.$axios.get('/wbhome/lawsList')
      return { list: (list.data && list.data.data) || {} }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return { list: {} }
    }
  },
}
</script>
